import React from 'react';

import SfiLoader from 'components/Additional/SfiLoader/SfiLoader';

import styles from './StopHere.module.css';

const StopHere = () => {
	return (
		<div className={styles.internal_loader}>
			<SfiLoader />
			<div className={styles.recalculation_loader_text}>
				<p className={styles.loader_text}>
					Thank you for your interest in Security First Insurance!
				</p>
				<p className={styles.loader_text}>
					We hope you'll keep us in mind for your future homeowner
					insurance needs.
				</p>
			</div>
		</div>
	);
};

export default StopHere;
